/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var MessageDirection;

(function (MessageDirection) {
  MessageDirection["INBOUND"] = "inbound";
  MessageDirection["OUTBOUND"] = "outbound";
  MessageDirection["OUTBOUND_API"] = "outbound-api";
  MessageDirection["OUTBOUND_CALL"] = "outbound-call";
  MessageDirection["OUTBOUND_REPLY"] = "outbound-reply";
})(MessageDirection || (MessageDirection = {}));